import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "@atenea-cms";

import { AteneaModule } from "@atenea-cms";
import { LandingsRoutes } from "./landings.routes";
import { LandingListComponent } from "./landing-list/landing-list.component";
import { LandingFormComponent } from "./landing-form/landing-form.component";
import { LandingSlideFormComponent } from "./landing-slide-form/landing-slide-form.component";
import { LandingService, LandingFormService } from "./shared";

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    AteneaModule,
    LandingsRoutes,
  ],
  declarations: [
    LandingListComponent,
    LandingFormComponent,
    LandingSlideFormComponent,
  ],
  providers: [LandingService, LandingFormService],
})
export class LandingsModule {}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/landings/landings.module.ts